import {
  marketingAutomationConditionPatch,
  marketingAutomationSendEmailPatch,
  marketingAutomationStepOperation,
  marketingAutomationStepUpdateOp,
} from "@redotech/redo-marketing-sdk/schema/automation-step-ops";
import { schemaKey } from "@redotech/zod-util/schema-key";
import * as z from "zod";

export const updateAutomationSteps = {
  name: "updateAutomationSteps" as const,
  description: `Applies step operations (${Object.keys(marketingAutomationStepOperation.shape).join(", ")}) to one automation and leaves every other step as it is. Use this to change a step instead of rewriting the whole automation. A ${schemaKey(marketingAutomationStepUpdateOp, "sendEmail")} step takes ${schemaKey(marketingAutomationSendEmailPatch, "templateId")} for a team email template or ${schemaKey(marketingAutomationSendEmailPatch, "originTemplateId")} for a shared origin template. A ${schemaKey(marketingAutomationStepUpdateOp, "condition")} update takes ${schemaKey(marketingAutomationConditionPatch, "naturalLanguageSummary")}, a plain-language description of what the new condition matches.`,
  mutates: true,
  input: z.object({
    automationId: z.string(),
    operations: z.array(marketingAutomationStepOperation).min(1),
  }),
  output: z.object({ success: z.boolean() }),
};
